<template>
    <IndexModelLayout
        :createRoute="$route('admin::languages.create')"
        :modelNamePlural="__('admin::languages.languages')"
    >

        <Table 
            :headings="[
                __('admin::languages.language'),
                __('admin::languages.locale'),
            ]"
            :paginator="paginator"
            @filter="submit"
        >

            <template #filters>
                <Input :placeholder="__('admin::forms.search')" v-model="filter.search" variant="filter" />
            </template>

            <template #results>
                <tr v-for="language in paginator.data" :key="language.id">
                    <td>{{ language.name }}</td>
                    <td>{{ language.locale }}</td>
                    <td>
                        <TableButton 
                            variant="edit" 
                            :href="$route('admin::languages.edit', { language: language.id })"
                        />
                        <TableButton 
                            variant="destroy" 
                            @delete="deleting = $route('admin::languages.destroy', { language: language.id })"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::languages.language') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </IndexModelLayout>
</template>

<script>
    export default {
        props: {
            paginator: Object,
            request: Object,
        },
        data() {
            return {
                filter: this.$inertia.form({
                    search: this.request.search,
                }),
                deleting: null,
            }
        },
        methods: {
            submit() {
                this.filter.get(this.$route('admin::languages.index'));
            },
        },
    }
</script>